"use strict";
/**
 * Types extracted from https://discord.com/developers/docs/resources/poll
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PollLayoutType = void 0;
/**
 * @see {@link https://discord.com/developers/docs/resources/poll#layout-type}
 */
var PollLayoutType;
(function (PollLayoutType) {
    /**
     * The, uhm, default layout type
     */
    PollLayoutType[PollLayoutType["Default"] = 1] = "Default";
})(PollLayoutType || (exports.PollLayoutType = PollLayoutType = {}));
//# sourceMappingURL=poll.js.map